// extracted by mini-css-extract-plugin
export var stepActive = "_2w-3";
export var stepCompleted = "_2w-4";
export var stepConnectorLine = "_2w-b";
export var stepIndicatorCircle = "_2w-6";
export var stepIndicatorCircleCompleted = "_2w-7";
export var stepIndicatorCircleDefault = "_2w-8";
export var stepIndicatorTextCompleted = "_2w-9";
export var stepIndicatorTextDefault = "_2w-a";
export var stepPending = "_2w-5";
export var wizardContainer = "_2w-1";
export var wizardContent = "_2w-2";
export var wizardModal = "_2w-0";